/* KB cart drawer (snippets/kb-cart.liquid). Modelled on the SA store's scp-cart-drawer.js.
   window.kbCart = { open, close, refresh, add }
   - open(): show the panel/sheet, then fetch /cart.js and render
   - /cart/change.js for quantity and remove (by line key); /cart/add.js for adds
   - every <form action="/cart/add"> on the page is submitted by AJAX and opens the cart
   - counts: [data-kb-cart-count] badges + Horizon's <cart-icon> bubble stay in sync
   - "You May Also Like": Shopify related recommendations for the first line item
   - delivery timeline: next-day Dubai & Abu Dhabi for orders by 4pm Gulf time */
(function () {
  var root = document.querySelector('[data-kb-cart]');
  if (!root || window.kbCart) return;
  var cfg = window.kbCartConfig || {};
  var panel = root.querySelector('.kb-cart__panel');
  var body = root.querySelector('[data-kb-cart-body]');
  var foot = root.querySelector('[data-kb-cart-foot]');
  var ship = root.querySelector('[data-kb-cart-ship]');
  var lastFocus = null;
  var recsFor = null; // product id the recommendations were built for
  var recsHtml = '';

  // UI strings come from snippets/kb-i18n.liquid (window.kbT, locale files kb.js.*); English is the fallback.
  function T(key, fallback, vars) {
    var str = (window.kbT && window.kbT[key]) || fallback;
    if (vars) Object.keys(vars).forEach(function (k) { str = str.split('{' + k + '}').join(vars[k]); });
    return str;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount}}';
    var n = (cents / 100).toFixed(2).split('.');
    var withCommas = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas;
      if (k === 'amount_with_comma_separator') return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
      return withCommas + '.' + n[1];
    });
  }

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kb-cart-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-shown'); }, 3200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-kb-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; });
    var label = root.querySelector('[data-kb-cart-countlabel]');
    if (label) label.textContent = n === 1 ? T('cart_count_one', '(1 item)', { count: n }) : T('cart_count_other', '({count} items)', { count: n });
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(n, false); } catch (e) {} }
  }

  // Cart endpoints can briefly answer 429 (bot check / throttle): retry twice with backoff.
  function cartFetch(url, opts, attempt) {
    attempt = attempt || 0;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && attempt < 2) {
        return new Promise(function (res) { setTimeout(res, 600 * (attempt + 1)); })
          .then(function () { return cartFetch(url, opts, attempt + 1); });
      }
      return r;
    });
  }
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  var seq = 0;
  function refresh() {
    var mine = ++seq;
    return cartFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) { if (mine === seq) render(cart); return cart; })
      .catch(function () {});
  }

  function shipBar(cart) {
    if (!ship) return;
    ship.hidden = cart.item_count === 0;
    var t = cfg.threshold || 15000;
    var left = t - cart.total_price;
    var pct = Math.min(100, Math.round(cart.total_price * 100 / t));
    ship.classList.toggle('is-done', left <= 0);
    ship.querySelector('[data-kb-cart-ship-label]').innerHTML = left > 0
      ? T('ship_away_html', 'You&rsquo;re <strong>{amount}</strong> away from free delivery', { amount: esc(money(left)) })
      : T('ship_unlocked_html', '&#10003; You&rsquo;ve unlocked <strong>free delivery</strong>');
    ship.querySelector('[data-kb-cart-ship-fill]').style.width = pct + '%';
    ship.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', pct);
  }

  function thumb(src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, function (m, ext, q) { return '_' + w + 'x' + ext + (q || ''); });
  }

  function lineHtml(item) {
    var struck = item.original_line_price > item.final_line_price ? item.original_line_price : 0;
    var variant = item.variant_title && item.variant_title.indexOf('Default') === -1 ? '<p class="kb-cart__variant">' + esc(item.variant_title) + '</p>' : '';
    var unit = item.quantity > 1 ? '<span class="kb-cart__unit">' + esc(money(item.final_price)) + ' &times; ' + item.quantity + '</span>' : '';
    return '<li class="kb-cart__item" data-kb-line data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
      '<a class="kb-cart__thumb" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(thumb(item.image, 160)) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
      '<div class="kb-cart__info"><div>' +
        (item.vendor ? '<p class="kb-cart__vendor">' + esc(item.vendor) + '</p>' : '') +
        '<a class="kb-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
      '</div><div class="kb-cart__bottom"><div>' +
        '<span class="kb-cart__price">' + esc(money(item.final_line_price)) + '</span>' +
        (struck ? '<s class="kb-cart__compare">' + esc(money(struck)) + '</s>' : '') + unit +
      '</div><div class="kb-cart__qty">' +
        '<button type="button" data-kb-qty="-1" aria-label="' + esc(T('decrease_quantity', 'Decrease quantity')) + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-kb-qty="1" aria-label="' + esc(T('increase_quantity', 'Increase quantity')) + '"' + (item.quantity >= 10 ? ' disabled' : '') + '>+</button>' +
      '</div></div></div>' +
      '<button type="button" class="kb-cart__remove" data-kb-remove aria-label="' + esc(T('remove_item', 'Remove {title}', { title: item.product_title })) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M10 11v6M14 11v6"/></svg>' +
      '</button></li>';
  }

  // Next-day delivery in Dubai & Abu Dhabi for orders placed by 4pm Gulf time (UTC+4).
  function timelineHtml() {
    var now = new Date();
    var gulfHour = (now.getUTCHours() + 4) % 24;
    var day = 86400000;
    var shipDay = gulfHour < 16 ? now : new Date(now.getTime() + day);
    var deliverDay = new Date(shipDay.getTime() + day);
    var f = function (d) { return d.toLocaleDateString(T('date_locale', 'en-GB'), { day: 'numeric', month: 'short', timeZone: 'Asia/Dubai' }); };
    var step = function (icon, label, date, done) {
      return '<div class="kb-cart__tstep"><span class="kb-cart__tdot' + (done ? ' kb-cart__tdot--done' : '') + '">' + icon + '</span>' +
        '<span class="kb-cart__tlabel">' + label + '</span><span class="kb-cart__tdate">' + date + '</span></div>';
    };
    var i = function (p) { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; };
    return '<div class="kb-cart__timeline" aria-label="' + esc(T('delivery_estimate', 'Delivery estimate')) + '"><span class="kb-cart__tline" aria-hidden="true"></span><div class="kb-cart__tsteps">' +
      step(i('<path d="M20 6 9 17l-5-5"/>'), T('ordered', 'Ordered'), f(now), true) +
      step(i('<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/>'), T('dispatched', 'Dispatched'), gulfHour < 16 ? T('today', 'today') : f(shipDay), false) +
      step(i('<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5"/>'), T('delivered', 'Delivered'), T('delivered_by', 'by {date}', { date: f(deliverDay) }), false) +
      '</div><p class="kb-cart__tnote">' + T('timeline_note_html', 'Dubai &amp; Abu Dhabi, order by 4pm. Other emirates 1 to 3 days.') + '</p></div>';
  }

  function render(cart) {
    setCount(cart.item_count);
    shipBar(cart);
    if (cart.item_count === 0) {
      body.innerHTML = cfg.emptyHtml || '';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    var list = body.querySelector('[data-kb-cart-items]');
    var html = cart.items.map(lineHtml).join('');
    if (list) list.innerHTML = html;
    else {
      body.innerHTML = '<div class="kb-cart__stack"><ul class="kb-cart__items" data-kb-cart-items>' + html + '</ul>' +
        '<div data-kb-cart-recs></div>' + timelineHtml() + '</div>';
    }
    var sub = foot.querySelector('[data-kb-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var sav = foot.querySelector('[data-kb-cart-savings]');
    if (sav) {
      sav.hidden = !(cart.total_discount > 0);
      if (cart.total_discount > 0) {
        sav.querySelector('[data-kb-cart-original]').textContent = money(cart.original_total_price);
        sav.querySelector('[data-kb-cart-discount]').textContent = '−' + money(cart.total_discount);
      }
    }
    recommendations(cart);
  }

  function recCard(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return '<div class="kb-cart__cs-card">' +
      '<a class="kb-cart__cs-media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(thumb(img, 300)) + '" alt="" width="144" height="144" loading="lazy">' : '') + '</a>' +
      '<div class="kb-cart__cs-body"><p class="kb-cart__cs-title">' + esc(p.title) + '</p>' +
      '<p class="kb-cart__cs-price">' + esc(money(v.price)) + '</p>' +
      '<button type="button" class="kb-cart__cs-add" data-kb-cs-add="' + v.id + '">' + esc(T('add', 'Add')) + '</button></div></div>';
  }

  function recommendations(cart) {
    var slot = body.querySelector('[data-kb-cart-recs]');
    if (!slot) return;
    var first = cart.items[0] && cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var paint = function () {
      var tmp = document.createElement('div');
      tmp.innerHTML = recsHtml;
      tmp.querySelectorAll('.kb-cart__cs-card').forEach(function (c) {
        if (inCart.indexOf(Number(c.getAttribute('data-pid'))) !== -1) c.remove();
      });
      var cards = tmp.querySelectorAll('.kb-cart__cs-card');
      slot.innerHTML = cards.length ? '<h3 class="kb-cart__sub">' + esc(T('you_may_also_like', 'You May Also Like')) + '</h3><div class="kb-cart__cs-scroll">' + tmp.innerHTML + '</div>' : '';
    };
    if (first === recsFor) { paint(); return; }
    recsFor = first;
    fetch('/recommendations/products.json?product_id=' + first + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        recsHtml = (data.products || []).filter(function (p) { return p.available; }).slice(0, 8).map(function (p) {
          return recCard(p).replace('<div class="kb-cart__cs-card">', '<div class="kb-cart__cs-card" data-pid="' + p.id + '">');
        }).join('');
        paint();
      })
      .catch(function () {});
  }

  function change(line, qty) {
    line.setAttribute('data-updating', '');
    cartFetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: qty }) })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
      .then(function (cart) { seq++; render(cart); })
      .catch(function () { line.removeAttribute('data-updating'); toast(T('update_error', 'Couldn’t update your bag. Please try again.')); });
  }

  function add(items, opts) {
    opts = opts || {};
    return cartFetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('add ' + r.status); });
        return r.json();
      })
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('kb:cart:added', { detail: res }));
        if (opts.open !== false) open(); else refresh();
        return res;
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || '';
        toast(/sold ?out|not available|inventory|already/i.test(msg) ? (err.description || T('unavailable', 'Sorry, that item is unavailable.')) : T('add_error', 'Couldn’t add to your bag. Please try again.'));
        throw err;
      });
  }

  function open() {
    if (root.hidden) {
      lastFocus = document.activeElement;
      root.classList.remove('is-closing');
      root.classList.add('is-opening');
      panel.addEventListener('animationend', function () { root.classList.remove('is-opening'); }, { once: true });
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      panel.style.transform = '';
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    }
    return refresh();
  }

  function close() {
    if (root.hidden || root.classList.contains('is-closing')) return;
    root.classList.add('is-closing');
    var done = function () {
      root.classList.remove('is-closing');
      root.hidden = true;
      panel.style.transform = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    var anims = panel.getAnimations ? panel.getAnimations() : [];
    if (anims.length) Promise.all(anims.map(function (a) { return a.finished; })).then(done, done);
    else done();
  }

  window.kbCart = { open: open, close: close, refresh: refresh, add: add };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kb-cart-open]')) { e.preventDefault(); open(); return; }
    var closer = e.target.closest('[data-kb-cart-close]');
    if (closer && root.contains(closer)) {
      if (closer.tagName !== 'A') e.preventDefault();
      close();
      return;
    }
    if (!root.contains(e.target)) return;
    var cs = e.target.closest('[data-kb-cs-add]');
    if (cs) {
      cs.disabled = true; cs.textContent = T('adding', 'Adding…');
      add([{ id: Number(cs.getAttribute('data-kb-cs-add')), quantity: 1 }]).catch(function () { cs.disabled = false; cs.textContent = T('add', 'Add'); });
      return;
    }
    var line = e.target.closest('[data-kb-line]');
    if (!line) return;
    var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
    var step = e.target.closest('[data-kb-qty]');
    if (step) change(line, Math.max(0, qty + Number(step.getAttribute('data-kb-qty'))));
    else if (e.target.closest('[data-kb-remove]')) change(line, 0);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Product forms (cards, PDP, sticky bar) add without leaving the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add(\?|$)/.test(form.action)) return;
    if (form.hasAttribute('data-kb-no-ajax')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = Number(fd.get('id'));
    if (!id) return;
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    // icon buttons (compact mobile cards) just dim while busy; text buttons say "Adding…"
    var iconOnly = btn && btn.querySelector('svg') && window.getComputedStyle(btn.querySelector('svg')).display !== 'none';
    if (btn) { btn.disabled = true; if (iconOnly) btn.classList.add('is-busy'); else btn.textContent = T('adding', 'Adding…'); }
    add([{ id: id, quantity: Number(fd.get('quantity')) || 1 }])
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = label; } })
      .catch(function () {});
  });

  // Phones: drag the handle or header down to close.
  (function () {
    var startY = 0, dy = 0, dragging = false;
    var mq = window.matchMedia('(max-width: 989px)');
    panel.addEventListener('pointerdown', function (e) {
      if (!mq.matches || !e.target.closest('[data-kb-cart-handle], .kb-cart__head') || e.target.closest('button, a')) return;
      dragging = true; startY = e.clientY; dy = 0;
      root.classList.add('is-dragging');
      try { panel.setPointerCapture(e.pointerId); } catch (err) {}
    });
    panel.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (dy > 100) { close(); return; }
      panel.style.transition = 'transform 0.2s ease';
      panel.style.transform = '';
      setTimeout(function () { panel.style.transition = ''; }, 220);
    }
    panel.addEventListener('pointerup', end);
    panel.addEventListener('pointercancel', end);
  })();

  setCount(cfg.initialCount || 0);
  if (!root.hidden) refresh();
  // Coming back from checkout with the browser's back button can show a stale count.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
